import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Analytics } from 'analytics2.0';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME } from 'src/app/constants/app.constants';
import { FunCollectionService } from '../common-functions/fun-collection.service';
@Component({
  selector: 'app-verify-process',
  templateUrl: './verify-process.component.html'
})
export class VerifyProcessComponent {

  constructor(private analyticSdk: Analytics, private fcs: FunCollectionService) {
  }
@Input() dataObj;
@Input() callingfrom;


buttonClicked(): void {
  console.log(this.dataObj);
  this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.OTHER_CARD, 0,this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.NUDGE_BUTTON,null,
    new Date().getTime(), [{key: 'type', value: this.dataObj.type}]
  )
}

}
